<template>
  <div class="login" :style="{ backgroundImage: `url('${screen}')` }">
    <div>
      <div class="show_validation_err_login">
        <div v-if="showNoValidEmail" class="validationEmailPhone alert-dismissible">
          <i class="fas fa-exclamation-circle me-2"></i>
          <span class="validation-message">{{ noValidMessage }}</span>
          <button type="button" class="btn-close btn-close-white validation-close" @click="showNoValidEmail = false"></button>
        </div>
        <div v-if="showForgotPass" class="forgotPassSuccess alert-dismissible">
          <i class="fas fa-exclamation-circle me-2"></i>
          <span class="validation-message">{{ tr.ready }}</span>
          <button type="button" class="btn-close btn-close-white validation-close" @click="showForgotPass = false"></button>
        </div>
      </div>

      <div class="container" :style="type === 6 ? 'margin-top:60px' : 'margin-top:0px'">
        <div class="change__lang">
          <span
            v-for="language in languageList"
            :key="language"
            :class="{ isActive: lg === language }"
            @click.prevent="changeLang(language)"
          >
            {{ language.toUpperCase() }}
          </span>
        </div>

        <div class="login__logo">
          <img :src="logo" alt="logo" />
        </div>

        <div class="login__content">
          <div class="fields" v-show="type === 1">
            <div class="text-center mt-4">
              <p class="welcome__label">{{ tr.welcome_label }}</p>
              <p class="welcome_decription">{{ tr.enter_login_and_pass }}</p>
            </div>

            <form class="mt-6" @submit.prevent="submit">
              <div class="fields__item input-group">
                <span class="icon__prepend"><i class="fas fa-envelope"></i></span>
                <input v-model="loginValue" autocomplete="on" type="text" class="form-control" :placeholder="tr.login_label" />
              </div>

              <div class="fields__item mt-4 input-group">
                <span class="icon__prepend"><i class="fas fa-lock"></i></span>
                <input v-model="password" autocomplete="on" :type="fieldType" class="form-control" :placeholder="tr.password_label" />
                <button class="icon__prepend btn-eye" type="button" @click="showPassword">
                  <i class="fa fa-eye" v-if="fieldType === 'text'"></i>
                  <i class="fa fa-eye-slash" v-else></i>
                </button>
              </div>

              <div class="fields__submit mt-4">
                <button class="btn btnLogin" type="submit" :disabled="loading">
                  <template v-if="!loading">{{ tr.enter_button_label }}</template>
                  <template v-else>
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    {{ tr.loading }}
                  </template>
                </button>
              </div>
            </form>

            <div class="text-center forgot_password">
              <span @click="type = 3">{{ tr.forgot_pass }}</span>
            </div>

            <div class="text-center py-3 px-1 text-white" @click="type = 5">
              {{ tr.accounts }}
            </div>
          </div>

          <div class="fields" v-if="type === 2">
            <div class="text-center mt-4">
              <p class="welcome__label">{{ tr.add_data }}</p>
              <div class="m-6">
                <span class="welcome_decription">{{ tr.pls_add_data }}</span>
              </div>
            </div>

            <form @submit.prevent="submitContact">
              <div class="fields__item mt-4 input-group">
                <span class="icon__prepend"><i class="fas fa-envelope"></i></span>
                <input v-model="email" type="text" class="form-control" :placeholder="tr.email_placeholder" />
              </div>

              <div class="fields__submit mt-4">
                <button class="btn" type="submit" :disabled="loading">{{ tr.continue_button_label }}</button>
              </div>
            </form>

            <div class="text-center forgot_password">
              <span @click="okBtn">{{ tr.skip_label }}</span>
            </div>
          </div>

          <div class="fields" v-show="type === 3">
            <div class="text-center mt-4 mb-4">
              <p class="welcome__label">{{ tr.restore_pass_label }}</p>
              <p class="welcome_decription">{{ tr.for_restore_pass_label }}</p>
            </div>

            <form class="mb-4" @submit.prevent="restoreEmail">
              <div class="fields__item forgot__pass input-group">
                <span class="icon__prepend"><i class="fas fa-envelope"></i></span>
                <input v-model="forgotPassLogin" type="text" class="form-control" :placeholder="tr.login_label" />
              </div>

              <div ref="recaptchaEl" class="recaptcha-wrap"></div>

              <div class="fields__submit mt-4">
                <button class="btn" type="submit">{{ tr.restore }}</button>
              </div>
            </form>

            <div class="text-center forgot_password">
              <button class="return__sign btn btn-outline-light" :disabled="loading" @click="type = 1">
                {{ tr.enter_button_label }}
              </button>
            </div>
          </div>

          <div class="fields" v-show="type === 4">
            <div class="text-center mt-4">
              <p class="welcome__label">{{ tr.title_confirm_email_modal }}</p>
              <div class="m-6">
                <span class="welcome_decription" v-html="tr.alert_message_confirm_email"></span>
              </div>
            </div>
            <div class="fields__submit mt-4">
              <button class="btn" @click="sendAgainEmail">{{ tr.send_again_button_label }}</button>
            </div>
            <div class="text-center forgot_password">
              <span @click="okBtn">{{ tr.skip_label }}</span>
            </div>
          </div>

          <div class="fields" v-show="type === 5">
            <div class="account-list mt-4">
              <div class="fields__account mb-3" v-for="(item, i) in accounts" :key="i" @click="submitAccount(item)">
                <div class="avatar bg-image-cover me-3" :style="{ backgroundImage: `url(${item.avatar.url})` }"></div>
                <span class="me-auto">{{ fullName(item) }}</span>
                <span class="material-icons" @click.stop="removeAccountItem(i)">close</span>
              </div>
            </div>
            <button class="return__sign btn btn-outline-light" :disabled="loading" @click="type = 1">
              {{ tr.changeLogin }}
            </button>
          </div>

          <div v-show="type === 6" class="fields">
            <div class="fieldsAgreement">
              <span class="mb-2 d-block">{{ tr.agreementTitle }}</span>
              <div style="text-align: justify" class="d-flex flex-column mb-2 f-13 text--white">
                <span v-for="(item, index) in tr.agreement" :key="index">{{ item }}</span>
              </div>
            </div>
            <div class="mt-4 w-100">
              <button type="button" class="btn btn-success w-100 btn-sm" @click="acceptRule">{{ t('common.accept') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showErrorBlock" class="modal-overlay" @click.self="enterAgain">
      <div class="modal-box">
        <div class="mt-4 mb-4 text-center">
          <i class="fas fa-exclamation-circle icon__alert"></i>
          <p class="err_login_label">{{ tr.error_login_or_password }}</p>
          <p class="mx-4 err_login_decription">{{ tr.wrong_password_label }}</p>
          <button class="errLoginBtn btn btn-link" @click="enterAgain">{{ tr.enter_again }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import logo from '@/assets/login/logo.svg';
import screen from '@/assets/login/background-login-page.png';
import {
  useAcceptAgreementMutation,
  useLoginMutation,
  useLoginWithAccountMutation,
  useRecoverPasswordMutation,
  useSendConfirmationEmailMutation,
  useUpdateProfileEmailMutation
} from '@/queries';
import { useLangStore } from '@/stores/lang';
import { useViewerStore } from '@/stores/viewer';
import { getAccounts, removeAccount } from '@/services/auth';
import { extractApiStatusCode } from '@/utils/apiError';

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
const ERROR_MESSAGE_BY_STATUS = {
  1: 'noChildErr',
  3: 'noServerId',
  4: 'noProfileorServer',
  6: 'noProfile',
  7: 'noUser',
  500: 'error_global'
};

const router = useRouter();
const { t } = useI18n();
const langStore = useLangStore();
const viewerStore = useViewerStore();
const loginMutation = useLoginMutation();
const loginWithAccountMutation = useLoginWithAccountMutation();
const recoverPasswordMutation = useRecoverPasswordMutation();
const sendConfirmationEmailMutation = useSendConfirmationEmailMutation();
const updateProfileEmailMutation = useUpdateProfileEmailMutation();
const acceptAgreementMutation = useAcceptAgreementMutation();

const loginValue = ref('');
const password = ref('');
const forgotPassLogin = ref('');
const type = ref(1);
const fieldType = ref('password');
const loading = ref(false);
const showErrorBlock = ref(false);
const showNoValidEmail = ref(false);
const showForgotPass = ref(false);
const isAgreeLicense = ref(false);
const noValidMessage = ref('');
const email = ref('');
const captcha = ref(false);
const accounts = ref(getAccounts());
const recaptchaEl = ref(null);
const recaptchaWidgetId = ref(null);

const languageList = ['kz', 'ru'];

const tr = computed(() => langStore.translations || {});
const lg = computed(() => langStore.translation || 'ru');

function cleanValue(value = '') {
  return value.replace(/\s+/g, '');
}

function parseStoredPerson() {
  try {
    return JSON.parse(localStorage.getItem('person') || '{}');
  } catch {
    return {};
  }
}

async function runWithLoading(action) {
  loading.value = true;
  try {
    await action();
  } finally {
    loading.value = false;
  }
}

function showErrorMessage(message) {
  noValidMessage.value = message || tr.value.error_global;
  showNoValidEmail.value = true;
}

function resolveStatusMessage(status) {
  const key = ERROR_MESSAGE_BY_STATUS[status] || 'error_global';
  const statusText = Number(status || 0) > 0 ? status : tr.value.apiStatusUnknown;
  return `${tr.value.apiStatusCode}: ${statusText}. ${tr.value[key] || tr.value.error_global}`;
}

function resolveNextLoginStep(auth) {
  if (!auth?.profile?.email) return 2;
  if (Number(auth?.profile?.email_confirm) === 0) return 4;
  if (!auth?.user?.is_agree_license) return 6;
  return 1;
}

function applyLoginSuccess(auth) {
  viewerStore.initFromStorage();
  showErrorBlock.value = false;
  isAgreeLicense.value = !auth?.user?.is_agree_license;

  const nextStep = resolveNextLoginStep(auth);
  if (nextStep === 1) {
    router.push('/feed');
    return;
  }

  type.value = nextStep;
  if (nextStep === 4) {
    email.value = auth?.profile?.email || '';
  }
}

function fullName(account) {
  return `${account?.profile?.profile?.first_name || ''} ${account?.profile?.profile?.last_name || ''}`.trim();
}

function changeLang(lang) {
  langStore.changeLang(lang);
}

function loadRecaptchaScript() {
  return new Promise((resolve, reject) => {
    if (window.grecaptcha) {
      resolve(window.grecaptcha);
      return;
    }

    const script = document.createElement('script');
    script.src = import.meta.env.VITE_RECAPTCHA_SITE_URL;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.grecaptcha);
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

async function initRecaptcha() {
  if (!RECAPTCHA_SITE_KEY) {
    captcha.value = true;
    return;
  }

  try {
    const grecaptcha = await loadRecaptchaScript();
    if (!recaptchaEl.value || recaptchaWidgetId.value !== null) {
      return;
    }
    recaptchaWidgetId.value = grecaptcha.render(recaptchaEl.value, {
      sitekey: RECAPTCHA_SITE_KEY,
      callback: () => {
        captcha.value = true;
      },
      'expired-callback': () => {
        captcha.value = false;
      }
    });
  } catch {
    captcha.value = false;
  }
}

function showPassword() {
  fieldType.value = fieldType.value === 'password' ? 'text' : 'password';
}

function enterAgain() {
  showErrorBlock.value = false;
  password.value = '';
}

function okBtn() {
  if (isAgreeLicense.value) {
    type.value = 6;
  } else {
    router.push('/feed');
  }
}

async function submitAccount(account) {
  try {
    await runWithLoading(async () => {
      const res = await loginWithAccountMutation.mutateAsync({ accountProfile: account.profile });
      applyLoginSuccess(res?._auth || {});
    });
  } catch (err) {
    errorHandler(err);
  }
}

async function submit() {
  loginValue.value = cleanValue(loginValue.value);
  password.value = cleanValue(password.value);

  try {
    await runWithLoading(async () => {
      const res = await loginMutation.mutateAsync({ login: loginValue.value, password: password.value });
      applyLoginSuccess(res?._auth || {});
    });
  } catch (err) {
    errorHandler(err);
  }
}

function errorHandler(err) {
  const status = extractApiStatusCode(err);

  if (status === 422) {
    showErrorBlock.value = true;
    return;
  }

  showErrorMessage(resolveStatusMessage(status));
}

async function restoreEmail() {
  showNoValidEmail.value = false;

  if (!forgotPassLogin.value) {
    showErrorMessage(tr.value.empty_input);
    return;
  }

  if (!captcha.value) {
    showErrorMessage(tr.value.captchaError);
    return;
  }

  try {
    await runWithLoading(async () => {
      await recoverPasswordMutation.mutateAsync({ loginValue: forgotPassLogin.value, language: lg.value });
      showForgotPass.value = true;
      forgotPassLogin.value = '';
      type.value = 1;
    });
  } catch (err) {
    showErrorMessage(err?.response?.data?.[0]?.message || tr.value.error_global);
  } finally {
    if (window.grecaptcha && recaptchaWidgetId.value !== null) {
      window.grecaptcha.reset(recaptchaWidgetId.value);
    }
    captcha.value = false;
  }
}

function removeAccountItem(index) {
  accounts.value = removeAccount(index);
}

async function sendAgainEmail() {
  try {
    await runWithLoading(async () => {
      await sendConfirmationEmailMutation.mutateAsync({ email: email.value });
      router.push('/feed');
    });
  } catch {
    showErrorMessage(tr.value.error_global);
  }
}

async function submitContact() {
  noValidMessage.value = '';
  showNoValidEmail.value = false;
  email.value = cleanValue(email.value);

  if (!email.value) {
    showErrorMessage(tr.value.empty_input);
    return;
  }

  const emailRegExp = /.{3,20}@[a-z]{2,20}\.[a-z]{2,4}/gi;
  if (!emailRegExp.test(email.value)) {
    showErrorMessage(`${tr.value.email_no_validation} (Bilimal@mail.ru)`);
    return;
  }

  try {
    await runWithLoading(async () => {
      const profileId = parseStoredPerson()?.profile?.id;
      await updateProfileEmailMutation.mutateAsync({ id: profileId, email: email.value });
      router.push('/feed');
    });
  } catch (err) {
    showErrorMessage(err?.response?.data?.[0]?.message || tr.value.unknown_error);
  }
}

async function acceptRule() {
  try {
    await runWithLoading(async () => {
      const userId = parseStoredPerson()?.profile?.user_id;
      await acceptAgreementMutation.mutateAsync({ userId });
      router.push('/feed');
    });
  } catch {
    router.push('/feed');
  }
}

onMounted(() => {
  initRecaptcha();
});
</script>

<style scoped>
::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

::-webkit-scrollbar-thumb {
  background: #7b7b7c;
  border-radius: 0;
}

::-webkit-scrollbar-thumb:hover {
  background: #626262;
}

::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 0;
  box-shadow: inset 7px 10px 12px #f0f0f0;
}

.btn-close:focus {
  box-shadow: none;
}

.fieldsAgreement {
  max-height: 500px;
  overflow: auto;
  color: #fff;
  padding: 10px 20px;
}

.change__lang {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #fff;
  margin-right: 17px;
  font-size: 18px;
}

.change__lang span {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  cursor: pointer;
}

.change__lang .isActive {
  background: #00c2ff;
}

.forgot__pass {
  margin-top: 30px;
}

.forgotPassSuccess,
.validationEmailPhone {
  width: 100%;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-weight: 500;
  min-height: 64px;
  padding: 16px;
  border-radius: 6px;
}

.validation-message {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
  line-height: 1.25;
}

.validation-close {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  padding: 8px;
  margin-left: auto;
  box-sizing: content-box;
}

.forgotPassSuccess {
  background: #36b453;
}

.validationEmailPhone {
  background: #f21837;
}

.show_validation_err_login {
  position: absolute;
  padding: 0 32px;
  top: 52px;
  width: 100%;
  z-index: 40;
}

@media screen and (max-width: 768px) {
  .show_validation_err_login {
    top: 16px;
    padding: 0 12px;
  }

  .show_validation_err_login > div {
    width: 100%;
    align-items: flex-start;
    min-height: 56px;
    padding: 12px;
    font-size: 14px;
  }

  .show_validation_err_login .fa-exclamation-circle {
    margin-top: 2px;
  }

  .validation-close {
    margin-top: -2px;
  }
}

@media screen and (min-width: 768px) {
  .show_validation_err_login > div {
    width: 60%;
    margin: auto;
  }
}

.return__sign {
  margin-top: 84px;
  width: 100%;
  height: 52px;
}

.icon__prepend {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  color: #bdbdbd;
  border: none;
  background: #fff;
}

.btn-eye {
  cursor: pointer;
}

.err_login_label {
  color: #eb5757;
  font-weight: bold;
  font-size: 24px;
  line-height: 21px;
}

.icon__alert {
  font-size: 72px;
  color: #eb5757;
  margin-bottom: 25px;
}

.errLoginBtn {
  width: 100%;
  height: 19px;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: #2f80ed;
}

.fields__account {
  background-color: rgba(20, 34, 47, 0.3);
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
}

.fields__account .avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 2px solid #fff;
  background-size: cover;
  background-position: center;
}

.fields__account span {
  word-break: break-word;
  max-width: 130px;
  color: #fff;
}

.err_login_decription {
  color: #828282;
}

.forgot_password {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  height: 52px;
  color: #fff;
}

.forgot_password span {
  cursor: pointer;
}

.login {
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  min-height: 100vh;
}

@media screen and (max-width: 768px) {
  .login {
    width: 100%;
  }
}

@media screen and (min-width: 768px) {
  .login {
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    max-width: 100% !important;
    margin-left: 0 !important;
  }
}

.login__logo {
  display: flex;
  justify-content: center;
}

.login__logo img {
  width: 150px;
  max-width: 260px;
}

.login__content {
  height: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.welcome__label {
  font-weight: 700;
  font-size: 26px;
  line-height: 26px;
  color: #fff;
}

.welcome_decription {
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: #fff;
}

.fields {
  margin-bottom: 16px;
  width: 296px;
}

.fields__item {
  width: 100%;
  height: 52px;
  background: #fff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #4f4f4f;
  overflow: hidden;
}

.fields__item .form-control {
  height: 52px;
  color: #4f4f4f;
  border: none;
}

.fields__item .form-control:focus {
  box-shadow: none;
}

.fields__submit {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.fields__submit .btn {
  width: 100%;
  height: 52px;
  border-color: #00c2ff;
  background: #00c2ff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  color: #fff;
}

.fields__submit .btn:disabled {
  opacity: 0.75;
}

.mt-6 {
  margin-top: 55px;
}

.m-6 {
  margin: 24px 0;
}

.f-13 {
  font-size: 0.8125rem;
}

.text--white {
  color: #fff;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 60;
}

.modal-box {
  width: 90%;
  max-width: 460px;
  border-radius: 8px;
  background: #fff;
  padding: 16px;
}

.recaptcha-wrap {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.account-list {
  max-height: 380px;
  overflow: auto;
}
</style>
